import { ChartItemInfo } from '../ChartItemInfo';
import HouseTrendIcon from './assets/redPoint.svg';
import MarketTrendIcon from './assets/bluePoint.svg';
import styles from './ChartInfo.css';

interface IChartInfoProps {
  magentaText: string | null;
  blueText: string | null;
}
export function ChartInfo({ magentaText, blueText }: IChartInfoProps) {
  return (
    <div className={styles['container']}>
      {magentaText && <ChartItemInfo src={HouseTrendIcon} text={magentaText} color="decorative__accent__magentum" />}
      {blueText && <ChartItemInfo src={MarketTrendIcon} text={blueText} color="primary_100" />}
    </div>
  );
}
